import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ChartTemplateGallery } from '../../components/chart/chart-template-gallery';
import { NestedPageHeader } from '../../components/header/page.header';

interface NewChartPageProps {
  parentId: string;
  parentObject: 'team' | 'tenant' | 'machine';
  defaultBackRoute: string;
  routerBuilder: (templateId: string) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  historyState?: () => any;
}

const SelectChartTemplatePage = (props: NewChartPageProps): ReactElement => {
  const {
    parentId,
    parentObject,
    defaultBackRoute,
    routerBuilder,
    historyState,
  } = props;
  const { i18n } = useTranslation();

  return (
    <IonPage>
      <NestedPageHeader
        title={i18n.t('common:chart_select_template')}
        defaultBackRoute={defaultBackRoute}
      />
      <IonContent>
        <ChartTemplateGallery
          parentObject={parentObject}
          parentId={parentId}
          routerBuilder={routerBuilder}
          historyState={historyState}
        />
      </IonContent>
    </IonPage>
  );
};

export { SelectChartTemplatePage };
